import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-black px-6">
      <div className="glass-card max-w-md rounded-3xl p-8 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-blue-300">
          404
        </p>
        <h1 className="mt-3 text-2xl font-semibold text-white">
          Page not found
        </h1>
        <p className="mt-2 text-sm text-white/60">
          The page you requested does not exist.
        </p>
        <Link
          to="/portal"
          className="mt-6 inline-flex rounded-full bg-blue-500 px-5 py-3 text-xs font-semibold uppercase tracking-[0.3em] text-white transition hover:bg-blue-400"
        >
          Back to portal
        </Link>
      </div>
    </div>
  );
}
